import { Reveal, RevealLines } from "./motion";

export default function PageHero({ eyebrow, title, intro, children }) {
  return (
    <section className="bg-ink text-white relative overflow-hidden pt-40 pb-16 lg:pt-48 lg:pb-20" data-testid="page-hero">
      <div
        className="absolute top-0 right-0 w-1/2 h-px bg-gradient-to-r from-transparent via-gold to-transparent pointer-events-none animate-gold-drift"
        aria-hidden="true"
      />
      <div className="wrap relative">
        <Reveal>
          <p className="eyebrow text-gold flex items-center gap-3 mb-6">
            {eyebrow} <span className="hidden sm:block h-px w-14 bg-gold/60" />
          </p>
        </Reveal>
        <h1 className="h-display font-bold text-[36px] sm:text-5xl lg:text-[64px] leading-[1.06] max-w-3xl">
          <RevealLines lines={title} />
        </h1>
        {intro && (
          <Reveal delay={0.15}>
            <p className="mt-7 text-mute text-[15.5px] sm:text-lg leading-relaxed max-w-2xl">{intro}</p>
          </Reveal>
        )}
        {children && <Reveal delay={0.22}>{children}</Reveal>}
      </div>
    </section>
  );
}
